import React from 'react'
import { participantApiV1 } from '../../api'
import dayjs from 'dayjs'

interface Item {
  id: number
  date: string
  created_at: string
  description: string
  title: string
  amount: number
  status?: string
  use_qr: boolean
}

interface State {
  items: Item[]
  loading: boolean
}

interface Props {}

class HistoryList extends React.Component<Props, State> {
  state: State = {
    items: [],
    loading: false
  }

  // is_qr - СБП
  withoutTaxAmount = (amount: number, is_qr: boolean = false) => {
    if (!amount) return 0
    return (amount / 100 - (amount / 100) * (is_qr ? 0.007 : 0.023)).toFixed(2)
  }

  taxAmount = (amount: number, is_qr: boolean = false) => {
    if (!amount) return 0
    return ((amount / 100) * (is_qr ? 0.007 : 0.023)).toFixed(2)
  }

  async componentDidMount() {
    this.setState({ loading: true })
    try {
      const response = await participantApiV1.get('/participants/payments')
      if (response.data.payments) {
        const sortedItems = response.data.payments.sort((a: Item, b: Item) => b.id - a.id)
        this.setState({ items: sortedItems })
      }
    } catch (error) {
      console.error(error)
    }
    await new Promise((resolve) => setTimeout(resolve, 100))
    this.setState({ loading: false })
  }

  render() {
    if (this.state.loading) {
      return (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh'
          }}
        >
          <i className="far fa-spinner fa-spin fa-3x text-primary"></i>
        </div>
      )
    }

    return (
      <div>
        <ul role="list">
          {this.state?.items?.length == 0 && <p>Еще не зарегистрировано ни одного платежа</p>}
          {this.state.items.map((item: Item, index: number) => (
            <li key={index} className="py-4">
              <div className="flex flex-col items-center sm:flex-row gap-x-0 sm:gap-x-4">
                <div className="flex flex-col flex-1 min-w-0 max-w-auto sm:max-w-[60%]">
                  <p className="text-sm font-normal" style={{ color: 'rgba(0, 0, 0, 0.74)' }}>
                    {dayjs(item?.created_at).format('DD.MM.YYYY HH:mm')} (мск.)
                  </p>

                  {/*{!!item?.status && (*/}
                  {/*  <>*/}
                  {/*    <p className="text-sm font-semibold text-appRed">*/}
                  {/*      <i className="far fa-exclamation-circle"></i> {item?.status}*/}
                  {/*    </p>*/}
                  {/*  </>*/}
                  {/*)}*/}

                  <p className="text-sm font-medium">{item.description.split(',').join(', ')}</p>
                </div>
                <div className="flex w-full sm:w-auto">
                  <dl className="w-full pt-3 space-y-3 text-sm font-medium text-gray-500 sm:w-auto">
                    <div className="flex items-start justify-between gap-x-1">
                      <dt>
                        Поступило в<br />
                        Региональное&nbsp;отделение
                      </dt>
                      <dd className="text-primary">
                        {this.withoutTaxAmount(item?.amount, item.use_qr)}&nbsp;
                        <i className="far fa-ruble-sign"></i>
                      </dd>
                    </div>

                    <div className="flex justify-between gap-x-1">
                      <dt>Комиссия банка - {item.use_qr ? <>0.7%</> : <>2.3%</>}</dt>
                      <dd className="text-appDarkRed">
                        {this.taxAmount(item?.amount, item.use_qr)}&nbsp;
                        <i className="far fa-ruble-sign"></i>
                      </dd>
                    </div>

                    <div className="flex items-center justify-between pt-3 text-gray-900">
                      <dt className="text-base">Всего</dt>
                      <dd className="text-base text-orange-600">
                        {item?.amount / 100}&nbsp;<i className="far fa-ruble-sign"></i>
                      </dd>
                    </div>
                  </dl>
                </div>
              </div>
            </li>
          ))}
        </ul>
      </div>
    )
  }
}

export default HistoryList
